import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './Navbar.css';
import Offcanvas from '../Commons/Offcanvas/Offcanvas';

function Navbar() {
    const [offcanvas, setOffcanvas] = useState(false);
    const handleOffCanvas = () => {
        setOffcanvas(true);
    }
    return (
        <div className='navbar-outer d-flex justify-content-between align-items-center w-100'>
            <div className="navbar-inner d-flex justify-content-between align-items-center w-100">
                <div className="navbar-left cta-text  d-flex justify-content-between align-items-center">
                    <Link to="https://www.facebook.com/limsinst" className='text-decoration-none'>
                        < i className='bxl  bx-facebook'></i>
                    </Link>
                    <Link to="https://www.instagram.com/lims.hmi/" className='text-decoration-none'>
                        < i className='bxl  bx-instagram'></i>
                    </Link>
                    <Link to="https://www.linkedin.com/company/lims-hotel-management-institute-siliguri-darjeeling/" className='text-decoration-none'>
                        < i className='bxl  bx-linkedin'></i>
                    </Link>
                </div>
                <div className="navbar-mid logo-text">
                    <Link to='/' className='text-decoration-none'>LIMS HOTEL MANAGEMENT INSTITUTE</Link>
                </div>
                <div className="navbar-right cta-text" onClick={handleOffCanvas}>
                    Menu
                    <i className='bx  bx-menu-close'></i>
                </div>
            </div>
            <Offcanvas offcanvas={offcanvas} setOffcanvas={setOffcanvas} />
        </div>
    )
}

export default Navbar;
